import {createAsyncThunk} from '@reduxjs/toolkit';
import {AxiosResponse} from 'axios';
import {ACTION_TYPE} from '../actions-types';
import {STORAGE_KEY} from '@/utils/enums/storage.enum';
import {IOrganizationUserInfo} from '../../utils/types';
import {userStorage} from '@/utils/services/storage.service';
import {getErrorResponse} from '@/utils/helpers';
import {
	IUserLoginRequest,
	IUserRegisterLoginResponse,
	IUserRegisterRequest,
	IUserChangeProfileRequest,
	IUserTable,
} from '@/utils/types/user.interface';
import {IAuthAppleRequest, IAuthGoogleRequest} from '@/utils/types';
import {UserService} from '@/utils/services/user.service';

export const userSignup = createAsyncThunk(
	ACTION_TYPE.USER_SIGNUP,
	async (reqBody: IUserRegisterRequest, {rejectWithValue}) => {
		try {
			const userResponse: AxiosResponse<IUserRegisterLoginResponse> = await UserService.create(reqBody);

			userStorage.set(STORAGE_KEY.JWT_BEARER_TOKEN, userResponse.data.tokens.jwtBearerToken);
			userStorage.set(STORAGE_KEY.REFRESH_TOKEN, userResponse.data.tokens.refreshToken);
			userStorage.set(STORAGE_KEY.USER_ID, userResponse.data.userInfo.id);

			return userResponse.data;
		} catch (error) {
			return rejectWithValue(getErrorResponse(error));
		}
	}
);

export const userLogin = createAsyncThunk(
	ACTION_TYPE.USER_LOGIN,
	async (reqBody: IUserLoginRequest, {rejectWithValue}) => {
		try {
			const userResponse: AxiosResponse<IUserRegisterLoginResponse> = await UserService.login(reqBody);

			userStorage.set(STORAGE_KEY.JWT_BEARER_TOKEN, userResponse.data.tokens.jwtBearerToken);
			userStorage.set(STORAGE_KEY.REFRESH_TOKEN, userResponse.data.tokens.refreshToken);
			userStorage.set(STORAGE_KEY.USER_ID, userResponse.data.userInfo.id);

			return userResponse.data;
		} catch (error) {
			return rejectWithValue(getErrorResponse(error));
		}
	}
);

export const authGoogleUser = createAsyncThunk(
	ACTION_TYPE.USER_LOGIN,
	async (reqBody: IAuthGoogleRequest, {rejectWithValue}) => {
		try {
			const userResponse: AxiosResponse<IUserRegisterLoginResponse> = await UserService.googleAuth(reqBody);

			userStorage.set(STORAGE_KEY.JWT_BEARER_TOKEN, userResponse.data.tokens.jwtBearerToken);
			userStorage.set(STORAGE_KEY.REFRESH_TOKEN, userResponse.data.tokens.refreshToken);
			userStorage.set(STORAGE_KEY.USER_ID, userResponse.data.userInfo.id);

			return userResponse.data;
		} catch (error) {
			return rejectWithValue(getErrorResponse(error));
		}
	}
);

export const authAppleUser = createAsyncThunk(
	ACTION_TYPE.USER_LOGIN,
	async (reqBody: IAuthAppleRequest, {rejectWithValue}) => {
		try {
			const userResponse: AxiosResponse<IUserRegisterLoginResponse> = await UserService.appleAuth(reqBody);

			userStorage.set(STORAGE_KEY.JWT_BEARER_TOKEN, userResponse.data.tokens.jwtBearerToken);
			userStorage.set(STORAGE_KEY.REFRESH_TOKEN, userResponse.data.tokens.refreshToken);
			userStorage.set(STORAGE_KEY.USER_ID, userResponse.data.userInfo.id);

			return userResponse.data;
		} catch (error) {
			return rejectWithValue(getErrorResponse(error));
		}
	}
);

export const userLogout = createAsyncThunk(ACTION_TYPE.USER_LOGOUT, () => userStorage.clear());

export const getUserInfo = createAsyncThunk(ACTION_TYPE.USER_GET_INFO, async (id: number, {rejectWithValue}) => {
	try {
		const userResponse: AxiosResponse<IOrganizationUserInfo> = await UserService.getUserInfo(id);

		return userResponse.data;
	} catch (error) {
		return rejectWithValue(getErrorResponse(error));
	}
});

// export const changePassword = createAsyncThunk(
// 	ACTION_TYPE.CHANGE_PASSWORD,
// 	async (reqBody: IChangePasswordRequest, {rejectWithValue}) => {
// 		try {
// 			await UserService.changePassword(reqBody);
// 		} catch (error) {
// 			return rejectWithValue(getErrorResponse(error));
// 		}
// 	}
// );

export const changeProfile = createAsyncThunk(
	ACTION_TYPE.CHANGE_USER_PROFILE,
	async (reqBody: IUserChangeProfileRequest, {rejectWithValue}) => {
		try {
			await UserService.changeProfile(reqBody);
		} catch (error) {
			return rejectWithValue(getErrorResponse(error));
		}
	}
);

export const getUsersTablesAndTickets = createAsyncThunk(
	ACTION_TYPE.USERS_TABLES_AND_TICKETS,
	async ({userId, eventId}: {userId: number; eventId: number}, {rejectWithValue}) => {
		try {
			const userResponse: AxiosResponse<IUserTable[] | []> = await UserService.getUserTables({userId, eventId});
			return userResponse.data;
		} catch (error) {
			return rejectWithValue(getErrorResponse(error));
		}
	}
);
